export default __webpack_public_path__ + "static/media/MejiaSucesores.2d1ee4f9.png";